<template>
  <div>
    <div class="w-100 pb-2">
      <div class="w-100">
        <MainSlider
          v-if="pageData.contents[0].imageList"
          type="submenu"
          :src="pageData.contents[0].imageList"
        />
      </div>
    </div>

    <pre class="pageDescription text-justify" v-if="pageData.contents[0].description">{{ pageData.contents[0].description }}</pre>

    <div class="columns mt-2">
      <div
        v-for="articleCol in pageData.childEntries.rows"
        :key="articleCol.id"
        class="column col-md-12 col-6 article-item-box"
      >
        <div class="article-item">
          <div>
            <h5>
              <strong>{{ articleCol.contents[0].title }}</strong>
            </h5>
            <div class="text-justify">{{ articleCol.contents[0].description }}</div>
          </div>
          <div class="d-flex justify-content-end mx-2 px-2">
            <router-link
              :to="articleCol.url"
              class="btn__chip"
            >{{ getCaption("caption.read_more_button") }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainSlider from "@/components/entry/MainSlider.vue";

export default {
  props: ["pageData"],

  components: {
    MainSlider
  }
};
</script>

<style>
a.btn__chip {
  margin-top: 10px;
}
.article-item-box {
  margin-bottom: 20px;
}
.article-item {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 15px;
}
</style>
